import React from 'react'

export default function MergePdfOverlay(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M30.3 8.7v23.2c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2v-28C1.8 2.1 3.2.6 5 .6h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6 1 .6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          d="M11.1 28.6c-.6 0-1.1-.4-1.1-1l-.1-18c0-.3.1-.5.3-.7.2-.2.5-.3.8-.3h9.4c.3 0 .6.1.8.3l3.4 3.1.1.1c.2.1.2.3.2.5l.1 14.9c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3H11.1Z"
          opacity=".49"
        />
        <path
          fill="currentColor"
          d="M8.3 27.4c-.6 0-1.1-.4-1.1-1l-.1-18c0-.3.1-.5.3-.7.2-.2.5-.3.8-.3h9.4c.3 0 .6.1.8.3l3.4 3.2.1.1c.2.1.2.3.2.5l.1 14.9c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3l-12.8-.1Z"
          opacity=".63"
        />
        <path
          fill="currentColor"
          d="M17.15 17.15h2.45c.23 0 .442.113.59.26.147.148.26.359.26.59v.5a.933.933 0 0 1-.32.685.976.976 0 0 1-.63.265h-2.35v2.25a.852.852 0 0 1-.26.589.852.852 0 0 1-.59.26h-.5a.85.85 0 0 1-.59-.26.85.85 0 0 1-.26-.589v-2.25H12.6a.851.851 0 0 1-.59-.26.851.851 0 0 1-.26-.59V18c0-.231.113-.442.26-.59a.851.851 0 0 1 .59-.26h2.35V14.8c0-.232.113-.442.26-.59a.851.851 0 0 1 .59-.26h.5c.231 0 .442.113.59.26.147.148.26.359.26.59v2.35Z"
        />
      </svg>
    </div>
  )
}
